import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthFacade } from '../../features/auth/facade/auth.facade';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const facade = inject(AuthFacade);
  let token: string | null = null;
  
  if (typeof window !== 'undefined' && window.localStorage) {
    token = localStorage.getItem('token');
  }

  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        facade.forceLogout(true);
      }
      return throwError(() => error);
    })
  );
};
